class Ciudad {
    latitud
    longitud
}
setLatCiudad()
setLongCiudad()

class Familia {
    latitud 
    longitud
}


function setLatCiudad() {
    Ciudad.latitud = -33.5924
}
function setLongCiudad() {
    Ciudad.longitud = -70.7044
}

var arrFamilias = []
function crearFamilias() {
    var max = 0
    while(max <= 5) {
        max = Math.random() * 10
    }
    for (let i = 0; i < max; i++) {
        arrFamilias.push(new Familia())
        arrFamilias[i].latitud = getRandLatitud()
        arrFamilias[i].longitud = getRandLongitud()
    }
}
crearFamilias()

function getRandLatitud() {
    var num = Math.random() * 0.01
    var signo = Math.random() < 0.5 ? -1 : 1;
    num = num * signo
    num = num + Ciudad.latitud
    return num
  }
  
  function getRandLongitud() {
    const rand = 0 + Math.random() * (0 + 9);
    var num = rand * 0.001
    var signo = Math.random() < 0.5 ? -1 : 1;
    num = num * signo
    num = num + Ciudad.longitud
    return num
  }

export {getRandLatitud, getRandLongitud, Ciudad, arrFamilias}